<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="39" height="31" viewBox="0 0 39 31">
    <g id="Gruppe_61" data-name="Gruppe 61" transform="translate(-248 -31)">
      <g id="Gruppe_10" data-name="Gruppe 10" transform="translate(-58 1)">
        <rect id="Rechteck_23" data-name="Rechteck 23" width="36" height="2" rx="1" transform="translate(307 51)" fill="#383737"/>
        <rect id="Rechteck_24" data-name="Rechteck 24" width="36" height="2" rx="1" transform="translate(307 59)" fill="#383737"/>
      </g>
      <text id="MENÜ" transform="translate(248 33)" fill="#383737" font-size="12" font-family="Helvetica-Bold, Helvetica" font-weight="700"><tspan x="0" y="9">MENÜ</tspan></text>
    </g>
  </svg>
</template>

<script>
export default {
name: "menuIcon"
}
</script>

<style scoped>

</style>